
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import  Edit  from "./components/Edit"
import { TESTComponent } from "./components/TESTComponent";
import TESTEdit from "./components/TESTEdit";
 
const AppRoutes = [
  {
    
        path: '/index.html',
    element: <Home />
    },
    {
        index: true,
        path: '/',
        element: <Home />
    },
  {
    path: '/edit',
    element: <Edit />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  },
  {
    path: '/test',
    element: <TESTComponent />
  },
  {
    path: '/testedit',
    element: <TESTEdit />
  }
];

export default AppRoutes;
